import * as Actions from '../actions';

const initialState = {
    courseList: [],
    listLoaded: false,
    repullCourse: false,
    copiedCourse: false,
    NewCourseName: '',
    courseListLoadedAfterSave: true,
    courseListSearchable: {
        companies: [],
        labels: []
    },
    currentCourse: {
        Active: 0,
        course_id: 0,
        CourseDescription: '',
        CourseEnrollmentDescription: '',
        Unscheduled: 0,
        assetList: [],
        allowDelete: false,
        CreateAuthID: 0,
        LastEditAuthID: 0,
        CreationDate: '',
        LastEditDate: '',
        IsLocked: 0,
        LockedByAuthID: 0,
        CopiedFromID: 0,
        qualification: {
            Active: false,
            qualification_course_id: 0,
            qualification_id: 0,
            Days: 0
        },
        app_qualification_id: 0,
        app_role_id: 0,
        introLevelCourse: {
            Active: false,
            Student: 0,
            Instructor: 0,
            Company: 0,
            Admin: 0
        },
        labels: []
    },
    editInfo: {
        CreationDate: '',
        LastEditDate: '',
        CreateAuthEmail: '',
        LastEditAuthEmail: ''
    },
    allQualifications: [],
    isCourseLoaded: false,
    allMajors: [],
    allInstructors: [],
    allModules: [],
    allLessons: [],
    companies: [],
    currentCourseInstructorList: [],
    currentCourseMajorList: [],
    currentCourseModuleList: [],
    currentCoursePrerequisiteList: [],
    potentialCoursePrerequisites: [],
    prerequisiteSearch: "",
    companySearch: "",
    month: 1,
    mappedLessons: [],
    duplicateLessons: [],
    overwrittenLessons: [],
    confirmDragDialog: false,
    confirmDragDialogInformation: {},
    modulePreviewData: [],
    courses_on_schedule: [],
    deleteAllowed: false,
    apps: []
}

const courseReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_COURSE):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        ...action.payload,
                        course_loaded: true
                    },
                    NewCourseName: action.payload.CourseName + ' - Copy'
                };
            }
        case (Actions.ACTIVATE_COURSE):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        Active: 1
                    }
                }
            }

        case (Actions.UPDATE_COURSE_FORM):
            {
                return {
                    ...state,
                    currentCourse: { ...state.currentCourse, ...action.payload }
                }
            }
        case (Actions.CLEAR_SCHEDULE):
            {
                const change = { Unscheduled: state.currentCourse.Unscheduled === 0 ? 1 : 0 }
                return {
                    ...state,
                    mappedLessons: [],
                    currentCourse: { ...state.currentCourse, ...change }
                }
            }
        case (Actions.GET_COURSE_ASSET_LIST):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        assetList: action.payload
                    }
                }
            }

        case (Actions.DELETE_COURSE):
            {
                return {
                    ...state,
                    currentCourse: { course_loaded: false },
                    courseList: state.courseList.map(c => {
                        if (c.course_id === action.payload) {
                            return {
                                ...c,
                                Active: 0
                            }
                        }
                        return c
                    })
                };
            }

        case (Actions.GET_COURSE_LIST):
            {
                return {
                    ...state,
                    listLoaded: true,
                    courseList: action.payload.courseList.courseList,
                    courseListSearchable: {
                        companies: action.payload.courseList.searchData.companies,
                        labels: action.payload.courseList.searchData.labels
                    },
                    courseListLoadedAfterSave: action.payload.call_location === 'list' ? state.courseListLoadedAfterSave : true
                };
            }

        case (Actions.UPDATE_COURSE_LOADED):
            {
                if (action.payload) {
                    return {
                        ...state,
                        isCourseLoaded: action.payload,
                    }
                } else {
                    // reset to default state
                    return {
                        ...initialState
                    }
                }
            }
        case (Actions.UPDATE_COURSE_LIST_LOADED):
            {
                return {
                    ...state,
                    courseListLoadedAfterSave: action.payload
                }
            }
        case (Actions.GET_ALL_MAJORS):
            {
                return {
                    ...state,
                    allMajors: action.payload
                }
            }
        case (Actions.GET_ALL_INSTRUCTORS):
            {
                return {
                    ...state,
                    allInstructors: action.payload
                }
            }
        case (Actions.GET_ALL_MODULES):
            {
                return {
                    ...state,
                    allModules: action.payload.moduleList
                }
            }
        case (Actions.GET_ALL_LESSONS):
            {
                return {
                    ...state,
                    allLessons: action.payload.lessonList.reverse()
                }
            }
        case (Actions.GET_RELATED_DATA):
            {
                return {
                    ...state,
                    currentCourseMajorList: action.payload.majors,
                    currentCourseModuleList: action.payload.modules,
                    mappedLessons: action.payload.lessons,
                    editInfo: action.payload.edit_info,
                    deleteAllowed: action.payload.deleteAllowed,
                    courses_on_schedule: action.payload.courses_on_schedule,
                    companies: action.payload.companies,
                    allCompanies: action.payload.allCompanies,
                    copiedCourse: action.payload.copiedCourse
                }
            }

        case (Actions.TOGGLE_MAJOR):
            {
                if (action.payload.action_type === 'ADD') {
                    let newMajor = state.allMajors.filter((major) => major.major_id === action.payload.major.id)
                    return {
                        ...state,
                        currentCourseMajorList: state.currentCourseMajorList.concat(newMajor)
                    }
                }
                else {
                    return {
                        ...state,
                        currentCourseMajorList: state.currentCourseMajorList.filter((major) => major.major_id !== action.payload.major.id)
                    }
                }
            }

        case (Actions.TOGGLE_MODULE):
            {
                if (action.payload.action_type === 'ADD') {
                    let newModule = state.allModules.filter((module) => module.module_id === action.payload.module.id)
                    return {
                        ...state,
                        currentCourseModuleList: state.currentCourseModuleList.concat(newModule)
                    }
                }
                else {
                    return {
                        ...state,
                        currentCourseModuleList: state.currentCourseModuleList.filter((module) => module.module_id !== action.payload.module.id)
                    }
                }
            }

        case (Actions.TOGGLE_COMPANY):
            {
                if (action.payload.action_type === 'ADD') {
                    let newCompany = state.allCompanies.filter((c) => c.id === action.payload.company.id)
                    return {
                        ...state,
                        companies: state.companies.concat(newCompany)
                    }
                }
                else {
                    return {
                        ...state,
                        companies: state.companies.filter((c) => c.id !== action.payload.company.id)
                    }
                }
            }
        case (Actions.TOGGLE_INSTRUCTOR):
            {
                if (action.payload.action_type === 'ADD') {
                    let newInstructor = state.allInstructors.filter((instructor) => instructor.instructor_id === action.payload.instructor.id)
                    return {
                        ...state,
                        currentCourseInstructorList: state.currentCourseInstructorList.concat(newInstructor)
                    }
                }
                else {
                    return {
                        ...state,
                        currentCourseInstructorList: state.currentCourseInstructorList.filter((instructor) => instructor.instructor_id !== action.payload.instructor.id)
                    }
                }
            }
        case (Actions.TOGGLE_MONTH):
            {
                if (action.payload === 'UP') {
                    return {
                        ...state,
                        month: state.month + 1
                    }
                }
                else {
                    return {
                        ...state,
                        month: state.month - 1
                    }
                }
            }
        case (Actions.CHECK_DAY_LESSON_CONFLICT):
            {
                let newLessonMap = action.payload.lessons.map(lesson => {
                    return {
                        LessonName: lesson.LessonName,
                        lesson_id: lesson.lesson_id,
                        // DisplayOrder: (lesson.WeekNum - 1) * 7 + lesson.DayOfWeek,
                        DisplayOrder: lesson.DisplayOrder,
                        WeekNum: action.payload.week + lesson.WeekNum - 1,
                        DayOfWeek: lesson.DayOfWeek,
                        module_id: lesson.module_id,
                        ModuleName: action.payload.module.ModuleName
                    }
                })
                let overwrittenLessons = newLessonMap.map(newLesson => {
                    let checkForConfict = state.mappedLessons.filter((currentLesson) => currentLesson.DayOfWeek === newLesson.DayOfWeek && currentLesson.WeekNum === newLesson.WeekNum)
                    if (checkForConfict.length > 0) {

                        return {
                            day: newLesson.DayOfWeek,
                            week: newLesson.WeekNum,
                            selected: 'NEW',
                            old: checkForConfict[0],
                            new: {
                                LessonName: newLesson.LessonName,
                                lesson_id: newLesson.lesson_id,
                                // DisplayOrder: (newLesson.WeekNum - 1) * 7 + newLesson.DayOfWeek,
                                DisplayOrder: 0,
                                WeekNum: newLesson.WeekNum,
                                DayOfWeek: newLesson.DayOfWeek,
                                module_id: newLesson.module_id,
                                ModuleName: newLesson.ModuleName
                            }
                        }
                    }
                    return null
                }).filter(lesson => lesson != null);
                return {
                    ...state,
                    overwrittenLessons: state.overwrittenLessons.concat(overwrittenLessons)
                }
            }
        case (Actions.CHECK_DUPLICATE_LESSON_CONFLICT):
            {
                let duplicateLessonsMap = action.payload.lessons.map(lesson => {
                    let checkForLesson = state.mappedLessons.filter(mappedLesson => mappedLesson.lesson_id === lesson.lesson_id)
                    if (checkForLesson.length > 0) {
                        return {
                            lesson_id: lesson.lesson_id,
                            selected: "NEW",
                            old: checkForLesson[0],
                            new: {
                                LessonName: lesson.LessonName,
                                lesson_id: lesson.lesson_id,
                                // DisplayOrder: (lesson.WeekNum - 1) * 7 + lesson.DayOfWeek,
                                DisplayOrder: lesson.DisplayOrder,
                                WeekNum: action.payload.week + lesson.WeekNum - 1,
                                DayOfWeek: lesson.DayOfWeek,
                                module_id: lesson.module_id,
                                ModuleName: action.payload.module.ModuleName
                            }
                        }
                    }
                    return null;
                }).filter(lesson => lesson != null);
                // console.log(duplicateLessonsMap)
                return {
                    ...state,
                    duplicateLessons: state.duplicateLessons.concat(duplicateLessonsMap)
                }
            }
        case (Actions.DROP_MODULE_TO_DAY):
            {
                // console.log(action.payload)
                let newLessonMap = action.payload.lessons.map(lesson => {
                    return {
                        LessonName: lesson.LessonName,
                        lesson_id: lesson.lesson_id,
                        // DisplayOrder: (lesson.WeekNum - 1) * 7 + lesson.DayOfWeek,
                        DisplayOrder: lesson.DisplayOrder,
                        WeekNum: action.payload.week + lesson.WeekNum - 1,
                        DayOfWeek: lesson.DayOfWeek,
                        module_id: lesson.module_id,
                        ModuleName: action.payload.module.ModuleName
                    }
                })
                let newCourseModule = {
                    DisplayOrder: 0,
                    course_id: action.payload.course_id,
                    module_id: action.payload.module.module_id,
                    course_module_rel_id: 'new_' + action.payload.module.module_id
                }
                return {
                    ...state,
                    currentCourseModuleList: state.currentCourseModuleList.concat(newCourseModule),
                    mappedLessons: state.mappedLessons.concat(newLessonMap)
                }
            }
        case (Actions.DROP_LESSON_TO_DAY):
            {
                const overwriteChecker = state.mappedLessons.filter(lesson => lesson.WeekNum === action.payload.week && lesson.DayOfWeek === action.payload.day && lesson.lesson_id !== action.payload.lesson.lesson_id);
                return {
                    ...state,
                    overwrittenLessons: overwriteChecker.length > 0 ? state.overwrittenLessons.concat({
                        day: action.payload.day,
                        week: action.payload.week,
                        selected: 'NEW',
                        old: overwriteChecker[0],
                        new: {
                            LessonName: action.payload.lesson.LessonName,
                            lesson_id: action.payload.lesson.lesson_id,
                            // DisplayOrder: (action.payload.week - 1) * 7 + action.payload.day,
                            DisplayOrder: 0,
                            WeekNum: action.payload.week,
                            DayOfWeek: action.payload.day,
                            module_id: action.payload.lesson.module_id,
                            ModuleName: action.payload.lesson.ModuleName
                        }
                    }) : [],
                    mappedLessons: state.mappedLessons.map(lesson => {
                        if (lesson.lesson_id === action.payload.lesson.lesson_id && lesson.module_id === action.payload.lesson.module_id) {
                            return {
                                ...lesson,
                                WeekNum: action.payload.week,
                                DayOfWeek: action.payload.day,
                                // DisplayOrder: (action.payload.week - 1) * 7 + action.payload.day
                                DisplayOrder: 0
                            }
                        }
                        return lesson
                    })
                }
            }
        case (Actions.DROP_ORPHAN_LESSON):
            {
                const overwriteChecker = state.mappedLessons.filter(lesson => lesson.WeekNum === action.payload.week && lesson.DayOfWeek === action.payload.day);
                const duplicateChecker = state.mappedLessons.filter(lesson => lesson.lesson_id === action.payload.lesson.lesson_id);
                const newLesson = {
                    course_lesson_rel_id: null,
                    course_module_rel_id: null,
                    LessonName: action.payload.lesson.LessonName,
                    lesson_id: action.payload.lesson.lesson_id,
                    // DisplayOrder: (action.payload.week - 1) * 7 + action.payload.day,
                    DisplayOrder: 0,
                    WeekNum: action.payload.week,
                    DayOfWeek: action.payload.day,
                    module_id: null,
                    ModuleName: null
                }

                if (overwriteChecker.length > 0 && duplicateChecker.length > 0) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.concat(newLesson),
                        duplicateLessons: state.duplicateLessons.concat({
                            lesson_id: action.payload.lesson.lesson_id,
                            selected: "NEW",
                            old: duplicateChecker[0],
                            new: {
                                LessonName: action.payload.lesson.LessonName,
                                lesson_id: action.payload.lesson.lesson_id,
                                // DisplayOrder: (action.payload.lesson.WeekNum - 1) * 7 + action.payload.lesson.DayOfWeek,
                                DisplayOrder: 0,
                                WeekNum: action.payload.week,
                                DayOfWeek: action.payload.day,
                                module_id: null,
                                ModuleName: null
                            }
                        }),
                        overwrittenLessons: state.overwrittenLessons.concat({
                            week: action.payload.week,
                            day: action.payload.day,
                            selected: "NEW",
                            old: overwriteChecker[0],
                            new: newLesson
                        })
                    }
                }

                if (overwriteChecker.length > 0) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.concat(newLesson),
                        overwrittenLessons: state.overwrittenLessons.concat({
                            week: action.payload.week,
                            day: action.payload.day,
                            selected: "NEW",
                            old: overwriteChecker[0],
                            new: newLesson
                        })
                    }
                }

                if (duplicateChecker.length > 0) {
                    return {
                        ...state,
                        mappedLessons: state.mappedLessons.concat(newLesson),
                        duplicateLessons: state.duplicateLessons.concat({
                            lesson_id: action.payload.lesson.lesson_id,
                            selected: "NEW",
                            old: duplicateChecker[0],
                            new: {
                                LessonName: action.payload.lesson.LessonName,
                                lesson_id: action.payload.lesson.lesson_id,
                                // DisplayOrder: (action.payload.lesson.WeekNum - 1) * 7 + action.payload.lesson.DayOfWeek,
                                DisplayOrder: 0,
                                WeekNum: action.payload.week,
                                DayOfWeek: action.payload.day,
                                module_id: null,
                                ModuleName: null
                            }
                        })
                    }
                }

                return {
                    ...state,
                    mappedLessons: state.mappedLessons.concat(newLesson)
                }
            }
        case (Actions.HANDLE_DUPLICATE_CHECK_CHANGE):

            return {
                ...state,
                duplicateLessons: state.duplicateLessons.map(lesson => {
                    if (lesson.lesson_id === action.payload.lesson_id) {
                        return {
                            ...lesson,
                            selected: action.payload.selected
                        }
                    }
                    return lesson
                })
            }

        case (Actions.HANDLE_OVERWRITE_CHECK_CHANGE):
            {
                return {
                    ...state,
                    overwrittenLessons: state.overwrittenLessons.map(lesson => {
                        if (lesson.week === action.payload.week && lesson.day === action.payload.day) {
                            return {
                                ...lesson,
                                selected: action.payload.selected
                            }
                        }
                        return lesson
                    })
                }
            }
        case (Actions.HANDLE_DUPLICATE_SUBMIT):
            {
                /** This is janky but it will take the IDs of New lesson (chosen to replace old lessons) so I can later filter by the ID to remove the old lesson from mappedLessons */
                /** I add module_ + module_id for the same reason. It will filter out the New lessons not wanted, and keep the old version */
                const newIDs = state.duplicateLessons.map(lesson => {
                    if (lesson.selected === 'NEW') {
                        return lesson.lesson_id
                    }
                    return + lesson.lesson_id + '_' + lesson.new.module_id
                })
                /** If you want to switch out for a new lesson, it takes the duplicateLessons object and casts it to the format of mappedLessons */
                const newDuplicatesToKeep = state.duplicateLessons.map(lesson => {
                    if (lesson.selected === 'NEW') {
                        return {
                            LessonName: lesson.new.LessonName,
                            lesson_id: lesson.new.lesson_id,
                            // DisplayOrder: (lesson.new.WeekNum - 1) * 7 + lesson.new.DayOfWeek,
                            DisplayOrder: 0,
                            WeekNum: lesson.new.WeekNum,
                            DayOfWeek: lesson.new.DayOfWeek,
                            module_id: lesson.new.module_id,
                            ModuleName: lesson.new.ModuleName
                        }
                    }
                    return null
                })
                /** first takes out the ID new lessons to be added. This removes both from the list. Then, only the new version is added in the concat right after
                 * Then it removes all null instances from the recasting map. Finally it removes the unwanted new lessons from the list by the module ID and the lesson ID
                 */
                return {
                    ...state,
                    mappedLessons: state.mappedLessons
                        .filter(lesson => newIDs.indexOf(lesson.lesson_id) === -1)
                        .concat(newDuplicatesToKeep)
                        .filter(lesson => lesson != null)
                        .filter(lesson => newIDs.indexOf(lesson.lesson_id + '_' + lesson.module_id) === -1),
                    duplicateLessons: []
                }
            }
        case (Actions.HANDLE_OVERWRITE_SUBMIT):
            {
                const daysToReplace = state.overwrittenLessons.map(lesson => {
                    return lesson.week + '_' + lesson.day
                })

                const overwritesToKeep = state.overwrittenLessons.map(lesson => {
                    if (lesson.selected === 'NEW') {
                        return lesson.new
                    }
                    else return lesson.old
                })

                return {
                    ...state,
                    mappedLessons: state.mappedLessons
                        .filter(lesson => daysToReplace
                            .indexOf(lesson.WeekNum + '_' + lesson.DayOfWeek) === -1)
                        .concat(overwritesToKeep),
                    overwrittenLessons: []
                }
            }
        case (Actions.REMOVE_LESSON_FROM_CALENDAR):
            {
                let entireModuleDeletedChecker = state.mappedLessons.filter(lesson => lesson.module_id === action.payload.module_id)
                return {
                    ...state,
                    mappedLessons: state.mappedLessons.filter((lesson) => lesson.lesson_id !== action.payload.lesson_id),
                    currentCourseModuleList: entireModuleDeletedChecker.length === 1 ? state.currentCourseModuleList.filter(module => module.module_id !== action.payload.module_id)
                        : state.currentCourseModuleList
                }
            }
        case (Actions.REMOVE_MODULE_FROM_CALENDAR):
            {
                return {
                    ...state,
                    mappedLessons: state.mappedLessons.filter((lesson) => lesson.module_id !== action.payload),
                    currentCourseModuleList: state.currentCourseModuleList.filter((module) => module.module_id !== action.payload)

                }
            }
        /** This brings up the dialog to allow moving of lesson. It saves the drag data to do a once off move if you allow.*/
        case (Actions.TOGGLE_CONFIRM_DRAG_DIALOG):
            {
                return {
                    ...state,
                    confirmDragDialog: action.payload.setting,
                    confirmDragDialogInformation: {
                        lesson: action.payload.lesson,
                        week: action.payload.week,
                        day: action.payload.day
                    }
                }
            }

        /** if yes is selected it does a once off move, and removes it from the module. Both reset the dialog to false and the lesson information to empty object */
        case (Actions.CONFIRM_DRAG_ALLOW):
            {
                const movingLesson = state.confirmDragDialogInformation
                const checkMovingLessonSquare = state.mappedLessons.filter(lesson => lesson.WeekNum === movingLesson.week && lesson.DayOfWeek === movingLesson.day)

                if (action.payload === true) {
                    return {
                        ...state,
                        confirmDragDialog: false,
                        confirmDragDialogInformation: {},
                        mappedLessons: state.mappedLessons.map(lesson => {
                            if (lesson.lesson_id === movingLesson.lesson.lesson_id) {
                                return {
                                    ...lesson,
                                    module_id: null,
                                    WeekNum: movingLesson.week,
                                    DayOfWeek: movingLesson.day
                                }
                            }
                            return lesson
                        }),
                        overwrittenLessons: checkMovingLessonSquare.length > 0 ? state.overwrittenLessons.concat({
                            day: movingLesson.day,
                            week: movingLesson.week,
                            selected: 'NEW',
                            old: checkMovingLessonSquare[0],
                            new: {
                                LessonName: movingLesson.lesson.LessonName,
                                lesson_id: movingLesson.lesson.lesson_id,
                                // DisplayOrder: (movingLesson.lesson.WeekNum - 1) * 7 + movingLesson.lesson.DayOfWeek,
                                DisplayOrder: 0,
                                WeekNum: movingLesson.week,
                                DayOfWeek: movingLesson.day,
                                module_id: null,
                                ModuleName: null
                            }
                        }) : []
                    }
                }
                return {
                    ...state,
                    confirmDragDialogInformation: {},
                    confirmDragDialog: false
                }

            }
        case (Actions.MODULE_PREVIEW):
            {
                if (state.modulePreviewData.filter(m => m.module_id === action.payload.module_id).length > 0) {
                    return { ...state }
                }
                return {
                    ...state,
                    modulePreviewData: state.modulePreviewData.concat({
                        module_id: action.payload.module_id,
                        lessons: action.payload.lessons
                    })
                }
            }
        // Actions for handling Course Prerequisites
        case (Actions.GET_CURRENT_COURSE_PREREQUISITE_LIST):
            {
                return {
                    ...state,
                    currentCoursePrerequisiteList: action.payload
                }
            }

        case (Actions.GET_POTENTIAL_COURSE_PREREQUISITES):
            {
                return {
                    ...state,
                    potentialCoursePrerequisites: action.payload
                }
            }

        case (Actions.TOGGLE_PREREQUISITE_COURSE):
            {
                if (action.payload.action_type === 'ADD') {
                    let newprerequisite = state.potentialCoursePrerequisites.filter((course) => course.course_id === action.payload.prerequisiteCourse.id)
                    return {
                        ...state,
                        currentCoursePrerequisiteList: state.currentCoursePrerequisiteList.concat(newprerequisite)
                    }
                }
                else {
                    return {
                        ...state,
                        currentCoursePrerequisiteList: state.currentCoursePrerequisiteList.filter((course) => course.course_id !== action.payload.prerequisiteCourse.id)
                    }
                }
            }

        case (Actions.GET_ALL_QUALIFICATIONS):
            {
                return {
                    ...state,
                    allQualifications: action.payload
                }
            }

        case (Actions.GET_APP_QUALIFICATION_DATA):
            {
                return {
                    ...state,
                    apps: action.payload
                }
            }

        case (Actions.UPDATE_COURSE_QUALIFICATION_FORM):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        qualification: { ...state.currentCourse.qualification, ...action.payload }
                    }
                }
            }

        case (Actions.UPDATE_COURSE_INTRO):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        introLevelCourse: { ...state.currentCourse.introLevelCourse, ...action.payload }
                    }
                }
            }
        case (Actions.PREREQUISITE_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    prerequisiteSearch: action.payload
                }
            }
        case (Actions.COMPANY_UPDATE_SEARCH):
            {
                return {
                    ...state,
                    companySearch: action.payload
                }
            }

        case (Actions.PUSH_UNSCHEDULED_LESSON_OUTSIDE_BUILDER):
            {

                const displayOrder = {
                    DisplayOrder: state.mappedLessons.length + 1,
                    WeekNum: 0,
                    DayOfWeek: 0
                }
                const selected = { selected: true }
                return {
                    ...state,
                    mappedLessons: state.mappedLessons.concat([{ ...action.payload.lesson, ...displayOrder }]),
                }
            }

        case (Actions.MOVE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER):
            {
                const reorder = (list, startIndex, endIndex) => {
                    const result = Array.from(list);
                    const [removed] = result.splice(startIndex, 1);
                    result.splice(endIndex, 0, removed);

                    return result;
                };

                return {
                    ...state,
                    mappedLessons: reorder(state.mappedLessons, action.payload.dragIndex, action.payload.hoverIndex).map((lesson, index) => {
                        return {
                            ...lesson,
                            DisplayOrder: index + 1
                        }
                    })
                }
            }

        case (Actions.DELETE_UNSCHEDULED_LESSON_OUTSIDE_BUILDER):
            {
                return {
                    ...state,
                    mappedLessons: state.mappedLessons
                        .filter(lesson => lesson.lesson_id != action.payload.lesson_id)
                        .map((lesson, index) => {
                            return {
                                ...lesson,
                                DisplayOrder: index + 1
                            }
                        })
                }
            }

        case (Actions.LOCK_COURSE):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        IsLocked: 1,
                        LockedByAuthID: action.payload
                    }
                }
            }

        case (Actions.UNLOCK_COURSE):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        IsLocked: 0,
                        LockedByAuthID: 0
                    }
                }
            }
        case (Actions.UPDATE_ASSET_NAME):
            {
                return {
                    ...state,
                    currentCourse: {
                        ...state.currentCourse,
                        assetList: state.currentCourse.assetList.map(asset => {
                            if (asset.header.asset_id === action.payload.asset_id) {
                                return {
                                    ...asset,
                                    header: {
                                        ...asset.header,
                                        AssetNewName: action.payload.newName,
                                        UneditedNewName: action.payload.saved ? action.payload.newName : asset.header.UneditedNewName
                                    }
                                }
                            }
                            return asset
                        })
                    }
                }
            }

        case (Actions.UPDATE_NEW_COURSE_NAME):
            {
                return {
                    ...state,
                    NewCourseName: action.payload
                }
            }
        case (Actions.TOGGLE_COURSE_REPULL):
            {
                return {
                    ...state,
                    repullCourse: action.payload
                }
            }

        default:
            {
                return state;
            }
    }
}

export default courseReducer;



// WEBPACK FOOTER //
// src/main/content/course/store/reducers/course.reducer.js